import { useState } from "react";
import { User } from "lucide-react";

const COLORS = ["#C2410C", "#0F766E", "#1D4ED8", "#7C2D12", "#15803D", "#B91C1C", "#0E7490", "#A16207"];

const initialsOf = (name) => (name || "").trim().split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0].toUpperCase()).join("");

const colorOf = (seed) => COLORS[[...(seed || "")].reduce((a, c) => a + c.charCodeAt(0), 0) % COLORS.length];

export const UserAvatar = ({ name, picture, size = 32, testId = "user-avatar" }) => {
  const [broken, setBroken] = useState(false);
  const style = { width: size, height: size };
  if (picture && !broken) {
    return <img data-testid={testId} src={picture} alt={name || "Profile photo"} referrerPolicy="no-referrer"
      onError={() => setBroken(true)} style={style} className="rounded-full object-cover border border-foreground/10 shrink-0" />;
  }
  const initials = initialsOf(name);
  if (initials) {
    return <div data-testid={testId} title={name} style={{ ...style, background: colorOf(name), fontSize: size * 0.4 }}
      className="rounded-full grid place-items-center text-white font-semibold shrink-0 select-none">{initials}</div>;
  }
  return <div data-testid={testId} style={style} className="rounded-full grid place-items-center bg-muted text-muted-foreground border border-border shrink-0">
    <User style={{ width: size * 0.55, height: size * 0.55 }} />
  </div>;
};
